import "./objectfit";

import Translator from "./utils/Translator";
import PrivatePolicy from "./utils/PrivatePolicy";
import Creator from "./creator/Creator";
import Satellite from "./satellite/Satellite";
import OfferCreator from "./utils/OfferCreator";
import Icons from "./utils/Icons";
import BigMenu from "./utils/BigMenu";
import Utils from "../../modules/utils/utils-js/theme/js/utils/Utils";
import Animator from "./utils/Animator";
import ProductPage from "./utils/ProductPage";
import Cart from "./Cart";
import Tracking, { JsProductInfo } from "./Tracking";

declare global {
	interface JQuery {
		slick: (...any) => JQuery;
	}
}

declare var FB: any;
declare var Slider: any;
declare var Bloodhound: any;
declare var initCookieConsent: any;

export default class Site {
	public static SESSION_CONSENTINFO = 'consentinfo';

	public static MOBILE = 768;

	public static SLICK_PREV = '<button type="button" class="slick-prev slick-navi-1"><i class="fa fa-arrow-left"></i></button>';
	public static SLICK_NEXT = '<button type="button" class="slick-next slick-navi-1"><i class="fa fa-arrow-right"></i></button>';
	public static SLICK_DOTS = (slider, i) => {
		return $('<button type="button slick-dot-1" />');
	};

	public static Tracking = Tracking;
	public static PrivatePolicy = PrivatePolicy;
	public static Translator = Translator;
	public static Creator = Creator;
	public static Cart = Cart;

	public static onContractAcceptForm($uid: JQuery): void {
		(<any> $uid).form();
	}

	public static onContractAccept($uid: JQuery): void {
		const $form = $('.contractaccept__form', $uid);
		const $pdf = $('.contractaccept__pdf', $uid);

		$pdf.on('click', () => {
			$form.show();
		});
	}

	public static onProductsSlider2($uid: JQuery): void {
		const $slider = $('.productsslider2__slider', $uid);

		(<any> $slider).slick({
			infinite: true,
			dots: false,

			prevArrow: `<button type="button" class="slick-prev"><img class="svg-inject" src="/theme/images/icon-arrow.svg"></button>`,
			nextArrow: `<button type="button" class="slick-next"><img class="svg-inject" src="/theme/images/icon-arrow.svg"></button>`,

			slidesToShow: 5,

			responsive: [{
				breakpoint: 1600,
				settings: {
					slidesToShow: 4,
				},
			}, {
				breakpoint: 1440,
				settings: {
					slidesToShow: 3,
				},
			}, {
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
				},
			}, {
				breakpoint: 750,
				settings: {
					arrows: false,
					slidesToShow: 1,
				},
			}],
		});

		(<any> $slider).on('breakpoint', () => {
			this.discover($slider);
		});

		this.discover($slider);
	}

	public static onProductsSlider($uid: JQuery): void {
		const $slider = $('.productsslider__slider', $uid);

		let options = {
			infinite: true,
			dots: false,

			prevArrow: '<button type="button" class="slick-prev"><i class="xi xi-arrow-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next"><i class="xi xi-arrow-right"></i></button>',
		};

		const vw = window.innerWidth;

		if (vw < 1024) {
			$('.productsslider__morebox', $slider).remove();
		}

		if ($uid.hasClass('productsslider--category')) {
			$.extend(options, {
				slidesToShow: 4,

				responsive: [{
					breakpoint: 2000,
					settings: {
						slidesToShow: 3,
					},
				}, {
					breakpoint: 1440,
					settings: {
						slidesToShow: 2,
					},
				}, {
					breakpoint: 1024,
					settings: {
						slidesToShow: 1,
					},
				}, {
					breakpoint: 576,
					settings: {
						arrows: false,
						slidesToShow: 1,
					},
				}],
			});
		}

		(<any> $slider).slick(options);

		this.discover($slider);
	}

	public static onSearchForm($form: JQuery, query: string): void {
		const $input = $('input[name="q"]', $form);

		$input.val(query);

		$input.focus(() => {
			$form.addClass('search--focused');
		});

		$input.blur(() => {
			$form.removeClass('search--focused');
		});
	}

	public static showHide($el: JQuery, show: boolean, force: boolean = false): void {
		if (force) {
			if (show) {
				$el.show();
			} else {
				$el.hide();
			}
		} else {
			if (show) {
				$el.slideDown();
			} else {
				$el.slideUp();
			}
		}
	}

	public static onOfferEditProductsForm($uid: JQuery, items: any): void {
		const $itable = $('.offercreatorform__table', $uid);
		const $itablebody = $('tbody', $itable);

		const $inewproduct = $('input[name="new_product"]', $itable);
		const $inewquantity = $('input[name="new_quantity"]', $itable);
		const $inewprice = $('input[name="new_price"]', $itable);
		const $inewdiscount = $('input[name="new_discount"]', $itable);

		const $iadd = $('.offereditproductsform__add', $itable);

		let products = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.whitespace,
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: '/api/products/json?q=%query%',
				wildcard: '%query%'
			}
		});

		const initAdd = () => {
			$inewproduct.data('product', null);
			$inewproduct.val('');
			$inewquantity.val(1);
			$inewprice.val('');
			$inewdiscount.val(0);
			$iadd.prop('disabled', true);
		};

		let index = 1;

		const keyFunc = (isnew: boolean, v: any, name: string): string => {
			let key = (isnew ? 'new_' : '');

			key += name + '_' + v.id;

			return key;
		}

		const createRow = (isnew: boolean, v: any, discount: number, price: number, quantity: number) => {
			let html = `
				<tr>
					<td class="col-ix">
			`;

			if (isnew) {
				html += `<input type="hidden" name="new[]" value="` + v.id + `">`;
			}

			html += index + `.
					</td>

					<td class="col-title">
			`;

			if (v.url) {
				html += `<a href="`+ v.url + `" target="_blank">` + v.title + `</a>`;
			} else {
				html += v.title;
			}

			html += `
					</td>
					<td class="col-discount">
						<div class="input input--text">
							<div class="input__widget">
								<input type="text" name="` + keyFunc(isnew, v, 'discount') + `" value="` + discount + `" class="input__input input__input--text">
							</div>
						</div>
					</td>
					<td class="col-price">
						<div class="input input--text">
							<div class="input__widget">
								<input type="text" name="` + keyFunc(isnew, v, 'price') + `" value="` + price + `" class="input__input input__input--text">
							</div>
						</div>
					</td>
					<td class="col-quantity">
						<div class="input input--text">
							<div class="input__widget">
								<input type="text" name="` + keyFunc(isnew, v, 'quantity') + `" value="` + quantity + `" class="input__input input__input--text">
							</div>
						</div>
					</td>
					<td class="col-tools"></td>
				</tr>
			`;

			const $tr = $(html);

			$itablebody.append($tr);

			const $iprice = $('.col-price input', $tr);
			const $idiscount = $('.col-discount input', $tr);

			$idiscount.on('change', (e) => {
				OfferCreator.getPriceForDiscount(v.fullprice, $idiscount.val(), (price) => {
					$iprice.val(price);
				});
			});

			$iprice.on('change', (e) => {
				OfferCreator.getDiscountForPrice(v.fullprice, $iprice.val(), (discount) => {
					$idiscount.val(discount);
				});
			});

			index ++;
		}

		(<any> $inewproduct).typeahead({
			hint: true,
			highlight: true,
			// minLength: 3,
		}, {
			source: products,
			displayKey: 'title',
		}).on('typeahead:selected', (e, v) => {
			v.fullprice = v.price;
			$inewproduct.data('product', v);
			$inewprice.val(v.price);
			$inewdiscount.val(0);
			$iadd.prop('disabled', false);
		});

		$inewdiscount.on('change', () => {
			const v = $inewproduct.data('product');

			if (v) {
				OfferCreator.getPriceForDiscount(v.fullprice, $inewdiscount.val(), (price) => {
					$inewprice.val(price);
				});
			}
		});

		$inewprice.on('change', () => {
			const v = $inewproduct.data('product');

			if (v) {
				OfferCreator.getDiscountForPrice(v.fullprice, $inewprice.val(), (discount) => {
					$inewdiscount.val(discount);
				});
			}
		});

		$iadd.on('click', (e) => {
			e.preventDefault();

			const val = $inewproduct.data('product');

			if (val.id) {
				createRow(true, val, $inewdiscount.val(), $inewprice.val(), $inewquantity.val());
				initAdd();
			}
		});

		items.forEach(v => {
			createRow(false, v, v.discount, v.price, v.quantity);
		});

		initAdd();

		(<any> $uid).form();
	}

	public static onOfferEditForm($uid: JQuery): void {
		const $ipaper = $('input[name="paper"]', $uid);
		const $iproforma = $('input[name="proforma"]', $uid);
		const $paper = $('.offercreatorform__paper', $uid);
		const $proforma = $('.offercreatorform__proforma', $uid);

		const updatePaper = (force: boolean = false) => {
			const v = $ipaper.is(':checked');

			this.showHide($paper, v, force);
		};

		const updateProforma = (force: boolean = false) => {
			const v = $iproforma.is(':checked');

			this.showHide($proforma, v, force);
		};

		$ipaper.on('change', () => {
			updatePaper();
		});

		$iproforma.on('change', () => {
			updateProforma();
		});

		updatePaper(true);

		updateProforma(true);

		(<any> $uid).form();
	}

	public static onOfferCreatorAskForm($uid: JQuery, options: any): void {
		const $iproducts = $('input[name="products"]', $uid);
		const $productspurpose = $('.offercreatoraskform__products-purpose', $uid);
		const $productsselect = $('.offercreatoraskform__products-select', $uid);
		const $iproductslist = $('input', $productsselect);

		const $ipaper = $('input[name="paper"]', $uid);
		const $iproforma = $('input[name="proforma"]', $uid);
		const $paper = $('.offercreatoraskform__paper', $uid);
		const $proforma = $('.offercreatorform__proforma', $uid);

		const updatePaper = (force: boolean = false) => {
			const v = $ipaper.is(':checked');

			this.showHide($paper, v, force);
		};

		const updateProforma = (force: boolean = false) => {
			const v = $iproforma.is(':checked');

			this.showHide($proforma, v, force);
		};

		$ipaper.on('change', () => {
			updatePaper();
		});

		$iproforma.on('change', () => {
			updateProforma();
		});

		updatePaper(true);

		updateProforma(true);

		const updateProducts = (force: boolean = false) => {
			const $sel = $iproducts.filter(':checked');

			if ($sel.length) {
				const v = parseInt($sel.val()) == 1;

				this.showHide($productspurpose, !v, force);
				this.showHide($productsselect, v, force);
			} else {
				$productspurpose.hide();
				$productsselect.hide();
			}
		};

		$iproducts.on('change', () => {
			updateProducts();
		});

		updateProducts(true);

		let products = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.whitespace,
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			remote: {
				url: '/api/products/json?q=%query%',
				wildcard: '%query%'
			}
		});

		(<any> $iproductslist).tagsinput({
			itemValue: (v) => {
				return v.id;
			},

			itemText: (v) => {
				return v.title;
			},

			typeaheadjs: {
				hint: true,
				highlight: true,
				source: products,
				displayKey: 'title',

				// source: (q, cb, acb) => {
				// 	$.getJSON('/api/products/json', {
				// 		q: q
				// 	}, (r) => {
				// 		acb(r);
				// 	});
				// }
			}
		})[0];

		$.each(options.productslist, (ix, v) => {
			(<any> $iproductslist).tagsinput('add', v);
		});

		// $iproductslist.on('typeahead:select', (e, v) => {
		// 	console.log(v);
		// });;

		let budgets = new Bloodhound({
			datumTokenizer: Bloodhound.tokenizers.whitespace,
			queryTokenizer: Bloodhound.tokenizers.whitespace,
			local: ['100', '500', '1000', '2000', '5000', '10000', '20000', '50000']
		});

		(<any> $('.offercreatoraskform__budget input')).typeahead({
			hint: true,
			highlight: true
		},
		{
			name: 'states',
			source: budgets
		});

		// $iproductslist.on('beforeItemAdd', (e) => {
		// 	const item = (<any> e).item;

		// 	if (!r.includes(item)) {
		// 		(<any> e).cancel = true;
		// 	}
		// });

		(<any> $uid).form();

		const $idate: any = $('.offercreatoraskform__date .datetimewidget__input--date', $uid);
		$idate.datepicker('option', 'minDate', 1);
	}

	public static onOfferCreatorForm($uid: JQuery): void {
		const $ipaper = $('input[name="paper"]', $uid);
		const $paper = $('.offercreatorform__paper', $uid);
		const $trs = $('.offercreatorform__table tbody tr', $uid);
		const $iproforma = $('input[name="proforma"]', $uid);
		const $proforma = $('.offercreatorform__proforma', $uid);

		const updatePaper = (force: boolean = false) => {
			const v = $ipaper.is(':checked');

			this.showHide($paper, v, force);
		};

		const updateProforma = (force: boolean = false) => {
			const v = $iproforma.is(':checked');

			this.showHide($proforma, v, force);
		};

		$ipaper.on('change', () => {
			updatePaper();
		});

		$iproforma.on('change', () => {
			updateProforma();
		});

		updatePaper(true);

		updateProforma(true);

		$trs.each((ix, el) => {
			const $tr = $(el);

			const fullprice = $tr.data('price');
			const $idiscount = $('.col-discount input', $tr);
			const $iprice = $('.col-price input', $tr);

			$idiscount.on('change', (e) => {
				OfferCreator.getPriceForDiscount(fullprice, $idiscount.val(), (price) => {
					$iprice.val(price);
				});
			});

			$iprice.on('change', (e) => {
				OfferCreator.getDiscountForPrice(fullprice, $iprice.val(), (discount) => {
					$idiscount.val(discount);
				});
			});
		});

		(<any> $uid).form();
	}

	public static onSatellite(): void {
		$(() => {
			let s = new Satellite();
			s.initHtml();
		});
	}

	public static onProductPage(info: JsProductInfo): void {
		Site.Tracking.eventProductView(info);
		ProductPage.init();

		$(() => {
			switch (window.location.hash) {
				case '#pokaz-online':
					$('.vproduct__formshows-online').trigger('click');
					break;

				case '#pokaz':
					$('.vproduct__formshows-standard').trigger('click');
					break;
			}
		});
	}

	public static onProductsList(categoryview: any): void {
		const $isorts = $('.filterbox__sortlist input[name="sort"]');
		const $ifilters = $('.shopaside__filters-item input[type="checkbox"]');
		const $ipricefrom = $('.shopaside__filters input[name="price_from"]');
		const $ipriceto = $('.shopaside__filters input[name="price_to"]');

		const getVals = () => {
			let result = {};

			result['sort'] = $isorts.filter(':checked').val();

			let filters = [];

			$ifilters.filter(':checked').each(function () {
				filters.push($(this).val())
			});

			result['f'] = filters;

			result['q'] = $('.vshop__wrap').data('searchquery');

			result['c1'] = $ipricefrom.val();
			result['c2'] = $ipriceto.val();

			return result;
		};

		const updateFunc = () => {
			const vals = getVals();

			const base = $('.vshop__wrap').data('base');
			const baseid = parseInt($('.vshop__wrap').data('base-id'));

			const sp = new URLSearchParams();

			$.each(vals, (k, v) => {
				if (typeof v != 'undefined' && v != '') {
					sp.set(k, v);
				}
			});

			const qq = sp.toString();
			const url = base + (qq != '' ? '?' + qq : '');

			if (baseid) {
				vals['category'] = baseid;
			}

			vals['url'] = url;

			window.history.pushState(null, null, url);

			const $list = $('.vproducts__list-wrap');

			$.ajax({
				url: '/api/products/list',
				method: 'get',
				data: vals,

				success: (r) => {
					$list.html(r.html);

					this.discover($list);
				},
			});
		};

		$isorts.on('change', function () {
			updateFunc();
		});

		let timer = null;

		$ifilters.on('change', function () {
			if (timer != null) {
				clearTimeout(timer);
			}

			timer = setTimeout(() => {
				updateFunc();
			}, 1000);
		});

		$ipricefrom.add($ipriceto).on('change', function () {
			if (timer != null) {
				clearTimeout(timer);
			}

			timer = setTimeout(() => {
				updateFunc();
			}, 300);
		});

		const $shopasidecats = $('.shopaside__cats');

		$('li', $shopasidecats).each((ix, el) => {
			const $li = $(el);

			if ($li.hasClass('selected')) {
				$li.parentsUntil($shopasidecats).addClass('selected');
			}
		});

		Tracking.eventCategoryView(categoryview);
	}

	public static onMainSlider(): void {
		const $slider = $('.mainslider');

		const $items = $('.mainslider__item', $slider);

		const wx = window.innerWidth;
		let muted = true;

		$items.each((ix, el) => {
			const $item = $(el);
			const $image = $('.mainslider__image', $item);

			const moviedesktop = $item.data('movie');
			const moviemobile = $item.data('moviemobile');

			if (moviedesktop || moviemobile) {
				const src = wx <= 768 ? (moviemobile ? moviemobile : moviedesktop) : (moviedesktop ? moviedesktop : moviemobile);

				let video: HTMLVideoElement = null;
				const tag = $image.is('a') ? 'a' : 'div';

				const $wrap = $(`
					<div class="mainslider__video">
						<${tag} class="mainslider__video-wrap">
							<video muted autoplay></video>
						</${tag}>

						<button class="mainslider__mute "><i class="xi xi-mute"></i></button>
					</div>
				`);

				if (tag == 'a') {
					$('a', $wrap).attr('href', $image.attr('href'));
				}

				const $video = $('video', $wrap);
				const $mute = $('.mainslider__mute', $wrap);

				$video.on('canplay', () => {
					$wrap.prependTo($item);

					video = <HTMLVideoElement> $video.get(0);

					$item.addClass('mainslider__item--video');
					$item.addClass('mainslider__item--video-inited');
					$item.toggleClass('mainslider__item--muted', video.muted);

					if (ix == 0) {
						video.play();
					}
				});

				$video.on('ended', () => {
					$slider.slick('slickNext');
				});

				$mute.on('click', (e) => {
					muted = !muted;

					$items.each((ix, el) => {
						const $i = $(el);
						const $v = $('video', $i);
						const v = <HTMLVideoElement> $v.get(0);
						v.muted = muted;

						$i.toggleClass('mainslider__item--muted', muted);
					});
				});

				$video.append('<source src="' + src + '" type="video/mp4">');

				Site.discover($wrap);
			}
		});

		$slider.slick({
			arrows: true,
			dots: true,
			infinite: true,
			speed: 200,

			customPaging: function (slider, i) {
				return $('<button type="button" />');
			},

			prevArrow: Site.SLICK_PREV,
			nextArrow: Site.SLICK_NEXT,

			responsive: [
				{
					breakpoint: this.MOBILE,
					settings: {
						arrows: false,
						dots: false,
					},
				},
			],
		});

		$slider.on('afterChange', (e, slick, slide) => {
			$('video', $items).each((ix, video: HTMLVideoElement) => {
				video.pause();
			});

			const $item = $items.eq(slide);

			if ($item.hasClass('mainslider__item--video')) {
				const video = <HTMLVideoElement> $('video', $item)[0];
				video.play();
			}
		});

		this.discover($slider);
	}

	public static onHome(): void {
		$(document).ready(() => {
			$('.vhome__services-text a').addClass('button button--type2');

			new Animator({
				path: '/theme/images/home/creator.ani',
				frames: 12,
				$el: $('.hotproducts__list .hotproducts__item').eq(0),
			});

			new Animator({
				path: '/theme/images/home/explore.ani',
				frames: 16,
				$el: $('.hotproducts__list .hotproducts__item').eq(2),
			});

			new Animator({
				path: '/theme/images/home/satellite.ani',
				frames: 14,
				$el: $('.hotproducts__list .hotproducts__item').eq(1),
			});
		});
	}

	public static scrollTo(top: number, force?: boolean): void {
		if (force) {
			$('html,body').scrollTop(top);
		} else {
			$('html,body').animate({
				scrollTop: top
			}, 900);
		}
	}

	public static onFranchisingPage(): void {

	}

	public static onFranchisingHome(): void {
		let $items = $('.franchpackagebox__item');
		let $details = $('.vfranchising__details');

		$details.hide();

		let This = this;

		$items.click(function (e) {
			e.preventDefault();

			let id = $(this).data('id');

			let url = '/franchising/packages/' + id;

			let hdata = (data) => {
				let $data = $(data);

				$details.addClass('vfranchising__details--content')
				This.discover($data);
				$details.empty().append($data);
				$details.slideDown();

				This.scrollTo($details.position().top - 100);
			};

			if ($details.hasClass('vfranchising__details--content')) {
				$details.slideUp(200, () => {
					$.get(url, hdata);
				});
			} else {
				$.get(url, hdata);
			}
		});

		// $items.eq(0).click();
	}

	public static updateFloat(): void {
		let $body = $('body');
		let top = $(window).scrollTop();

		$body.toggleClass('body--float-150', top >= 150);
		$body.toggleClass('body--no-float-150', top < 150);
	}

	public static discover($parent?: JQuery): void {
		PrivatePolicy.discover($parent);

		let played = false;

		setInterval(() => {
			played = false;
		}, 200);

		$('.js-hover-sfx-1', $parent).hover(
			() => {
				if (!played) {
					let audio = new Audio('/theme/audio/flyby.mp3');
					audio.play();

					played = true;
				}
			},

			() => {}
		);

		Cart.discover($parent);

		$('.productsslider__item, .productslist__item', $parent).each((ix, el) => {
			const $el = $(el);

			$('a', $el).on('click', function (e) {
				$el.addClass('flash');
			});
		});

		(<any> $('.svg-inject', $parent)).svgInject();

		$('.lightbox, .fancybox, a[rel="lightbox"]', $parent).each(function() {
			var $el=$(this);

			(<any> $el).fancybox({
				titlePosition: 'over',

				width: $el.data('lightbox-width'),
				height: $el.data('lightbox-height'),

				type: $el.hasClass('js-lightbox--iframe') ? 'iframe' : null,

				onComplete: function() {
					$('#fancybox-frame').attr("allowfullscreen", "allowfullscreen");
				}
			});
		});

		$('.cmstext table').wrap('<div class="cmstext-table">');

		$('.js-window', $parent).click(function (e) {
			e.preventDefault();

			var wx = $(window).width();
			var width = wx * 0.5;
			var height = 600;

			var left = Math.round((wx  - width)  / 2);
			var top = Math.round(($(window).height() - height) / 2);

			var opts = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

			console.log(opts);

			return window.open($(this).data('url'), $(this).data('title'), opts);
		});


		Icons.discover($parent);
	}

	public static initVendors($uid: JQuery): void {
		const $slider = $('.vendors__list', $uid);
		const $_slider = (<any> $slider);

		const $vendors = $('.vendors__item', $uid);

		$vendors.each((ix, el) => {
			const $vendor = $(el);

			$vendor.on('click', (e) => {
				$vendors.not($vendor).removeClass('vendors__item--active');
				$vendor.toggleClass('vendors__item--active');
			});
		});

		$_slider.slick({
			mobileFirst: true,

			arrows: true,
			dots: true,
			infinite: true,

			adaptiveHeight: true,

			customPaging: this.SLICK_DOTS,
			prevArrow: this.SLICK_PREV,
			nextArrow: this.SLICK_NEXT,

			responsive: [
				{
					breakpoint: this.MOBILE,
					settings: 'unslick',
				},
			],
		});

		// this.discover($slider);
	}

	public static initHeaderSearchForm(): void {
		const $form = $('.header__search .searchform');
		const $inner = $('.searchform__inner', $form);

		let timer = null;

		$inner.hover(
			() => {
				if (timer != null) {
					clearTimeout(timer);
					timer = null;
				}

				$form.addClass('searchform--hover');
			},

			() => {
				timer = setTimeout(() => {
					$form.removeClass('searchform--hover');

					timer = null;
				}, 1000);
			}
		)
	}

	private static initFooterMobile(): void {
		const $footer = $('.footer-mobile');

		const $searchbtn = $('.footer-mobile__search-button', $footer);
		const $searchform = $('.footer-mobile__search form', $footer);
		const $iquery = $('input', $searchform);

		$searchbtn.on('click', (e) => {
			e.preventDefault();

			$footer.toggleClass('footer-mobile--search');

			$iquery.focus();
		});
	}

	private static initFloatingContact(): void {
		const $widget = $('.floating-contact');
		const $toggle = $('.floating-contact__toggle', $widget);
		const $itemWrapper = $('.floating-contact__items', $widget);

		$toggle.on('click', () => {
			$widget.toggleClass('floating-contact-active');
			$itemWrapper.slideToggle();
		});
	}

	public static initConsentInfo(): void {
		const $consent = $('.consentinfo');

		if (sessionStorage.getItem(this.SESSION_CONSENTINFO) != '1') {
			const $accept = $('.consentinfo__accept', $consent);

			$consent.show();
			$('body').addClass('body--lock');

			$accept.on('click', (e) => {
				sessionStorage.setItem(this.SESSION_CONSENTINFO, '1');

				$consent.fadeOut();
				$('body').removeClass('body--lock');
			});
		}
	}

	public static initCookies(): void {
		const cc = initCookieConsent();

		const $overlay = $(`<div class="cc__overlay">`);

		$('body').append($overlay);
		$('body').addClass('cc-visible');

		cc.run({
			current_lang: 'pl',
			autoclear_cookies: true,
			page_scripts: true,

			languages: {
				'pl': {
					consent_modal: {
						title: 'Informacja o polityce przetwarzania danych osobowych',
						description: `
							<div class="cc__body">
								<p>Drogi Użytkowniku, niniejszym informujemy Cię, że przetwarzamy Twoje dane osobowe. Zapoznaj się proszę z poniższymi informacjami:</p>

								<h2>I. Administrator danych osobowych</h2>
								<p>Administratorem Twoich danych osobowych jest Michał Matuszak, prowadzący działalność gospodarczą pod firmą MICHAŁ MATUSZAK VENUS, ul. Legionów 52, 62-800 Kalisz, wpisany do Centralnej Ewidencji i Informacji o Działalności Gospodarczej, NIP: 6182080633, REGON: 301571853. Nr telefonu: +48 697 201 835. E-mail: <a href="info@venus-beauty.pl">info@venus-beauty.pl</a>.</p>

								<h2>II. Cele i podstawa prawna przetwarzania</h2>
								<p>Twoje dane osobowe w postaci adresu IP, danych zawartych w plikach cookies i danych lokalizacyjnych przetwarzamy w celu umożliwienia Ci wejścia na naszą stronę i przeglądania jej zawartości, na podstawie Twojej zgody – podstawa z art. 6 ust. 1 lit. a Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z 27.04.2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych, tj. RODO).</p>

								<h2>III. Odbiorcy danych</h2>
								<p>Twoje dane osobowe możemy udostępniać hostingodawcy. Takie podmioty przetwarzają dane na podstawie umowy z nami i tylko zgodnie z naszymi poleceniami. Przekazujemy Twoje dane poza teren Polski/UE/Europejskiego Obszaru Gospodarczego. Z Twoich danych osobowych może także korzystać Google <a href="/polityka-prywatnosci,13">(Polityka prywatności i Warunki korzystania z usług Google)</a>.</p>

								<h2>IV. Okres przechowywania danych</h2>
								<p>Twoje dane przechowujemy do czasu posiadania udzielonej przez Ciebie zgody.</p>

								<h2>V. Twoje prawa</h2>
								<p>Przysługuje Ci prawo dostępu do swoich danych oraz otrzymania ich kopii, prawo do sprostowania (poprawiania) swoich danych, prawo do usunięcia danych (jeżeli Twoim zdaniem nie ma podstaw do tego, abyśmy przetwarzali Twoje dane, możesz zażądać, abyśmy je usunęli), prawo do ograniczenia przetwarzania danych (możesz zażądać, abyśmy ograniczyli przetwarzanie Twoich danych osobowych wyłącznie do ich przechowywania lub wykonywania uzgodnionych z Tobą działań, jeżeli Twoim zdaniem mamy nieprawidłowe dane na Twój temat lub przetwarzamy je bezpodstawnie), prawo do wniesienia sprzeciwu wobec przetwarzania danych, prawo do przenoszenia danych, prawo do wniesienia skargi do organu nadzorczego (Prezesa Urzędu Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa) oraz prawo do cofnięcia zgody na przetwarzanie danych osobowych (masz prawo cofnięcia zgody na przetwarzanie danych w dowolnym momencie; cofnięcie zgody nie ma wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie Twojej zgody przed jej cofnięciem).
								W celu wykonania swoich praw skieruj do nas odpowiedni wniosek.</p>

								<h2>VI. Informacja o dobrowolności podania danych</h2>
								<p>Podanie przez Ciebie danych jest dobrowolne. Jeżeli nie podasz danych, nie będziesz mógł przeglądać zawartości naszej strony.</p>

								<h2>VII. Zautomatyzowane podejmowanie decyzji</h2>
								<p>
									Na stronie sklepu są wykorzystywane pliki cookies. Stosowane są one w celach zapewnienia maksymalnej wygody wszystkich użytkowników (w tym użytkowników) przy korzystaniu ze sklepu (zapamiętywanie preferencji i ustawień na stronie, zbieranie anonimowych danych dla celów reklamowych i statystycznych, także przez inne portale, w tym portale społecznościowe, np. Facebook, oraz Google). Korzystanie ze sklepu bez zmiany ustawień w przeglądarce dotyczących cookies oznacza, że będą one zamieszczane w urządzeniu końcowym (np. komputerze) każdego użytkownika. Jeżeli użytkownik nie wyraża zgody na stosowanie plików cookies powinien zmienić ustawienia swojej przeglądarki.
									O przetwarzaniu Twoich danych osobowych oraz wykorzystywaniu plików cookies dowiesz się więcej z <a href="/polityka-prywatnosci,13">"Polityki Prywatności"</a> oraz <a href="/polityka-plikow-cookies">"Polityki plików cookies"</a>.
								</p>
							</div>
						`,

						primary_btn: {
							text: 'zaakceptuj wszystkie',
							role: 'accept_all',
						},

						secondary_btn: {
							text: 'zaakceptuj tylko niezbędne',
							role: 'accept_necessary',
						},
					},
					settings_modal: {
						title: 'Ustawienia ciasteczek',
						save_settings_btn: 'Zapisz',
						accept_all_btn: 'Zaakceptuj wszystkie',
						reject_all_btn: 'Odrzuć wszystkie',
						close_btn_label: 'Zamknij',
						blocks: [
							{
								description: 'Poniżej możesz sprawdzić, jakie dane zbieramy w ciasteczkach i po co je zbieramy. Nie na wszystkie musisz się zgodzić. Zawsze możesz zmienić swój wybór.'
							}, {
								title: 'Niezbędne do działania strony',
								description: 'Te pliki są niezbędne do działania naszej strony internetowej, dlatego też nie możesz ich wyłączyć.',
								toggle: {
									value: 'necessary',
									enabled: true,
									readonly: true
								}
							}, {
								title: 'Funkcjonalne',
								description: 'Te pliki umożliwiają Ci korzystanie z pozostałych funkcji strony internetowej (innych niż niezbędne do jej działania). Ich włączenie da Ci dostęp do pełnej funkcjonalności strony.',
								toggle: {
									value: 'functions',
									enabled: false,
									readonly: false
								},
							}, {
								title: 'Analityczne',
								description: 'Te pliki pozwalają nam na dokonanie analiz dotyczących naszego serwisu internetowego, co może przyczynić się do jego lepszego funkcjonowania i dostosowania do potrzeb Użytkowników.',
								toggle: {
									value: 'analytics',
									enabled: false,
									readonly: false
								},
							}, {
								title: 'Marketingowe',
								description: 'Dzięki tym plikom możemy prowadzić działania marketingowe.',
								toggle: {
									value: 'ads',
									enabled: false,
									readonly: false
								}
							}
						]
					}
				}
			},

			onAccept: (cookie) => {
				if (cookie.categories.includes('analytics')) {
					Tracking.gtag('consent', 'update', {
						'analytics_storage': 'granted'
					});
				}

				if (cookie.categories.includes('ads')) {
					Tracking.gtag('consent', 'update', {
						'ad_storage': 'granted',
						'ad_user_data': 'granted',
						'ad_personalization': 'granted',
					});
				}

				if (cookie.categories.includes('functions')) {
					Tracking.gtag('consent', 'update', {
						'functionality_storage': 'granted',
						'personalization_storage': 'granted',
						'security_storage': 'granted',
					});

					Translator.init();
				}

				Tracking.accept();

				$overlay.remove();
				$('body').removeClass('cc-visible');
			},
		});

		const $settings = $(`<button type="button" data-cc="c-settings" class="cc__settings">dostosuj zgody</button>`);

		$settings.on('click', (e) => {
			cc.showSettings();
		});

		$('#c-bns').append($settings);
	}

	public static initHtml(): void {
		this.discover();
		this.updateFloat();

		this.initHeaderSearchForm();

		BigMenu.initMenus();

		$('.js-gotop').on('click', (e) => {
			e.preventDefault();

			Utils.scrollTo(0);
		});

		this.initFooterMobile();
		this.initFloatingContact();
		this.initConsentInfo();
		this.initCookies();
	}

	public static evalJs(): void {
		(<any> window)._js = (h: () => void) => {
			h();
		};

		let js = (<any> window)._jslist;

		$.each(js, (k, v) => {
			v();
		});
	}

	public static init(): void {
		(<any> window).Site = Site;

		PrivatePolicy.init();
		Cart.init();

		$(window).scroll(this.updateFloat);

		$(() => {
			this.initHtml();
		});

		$(window).on('load', (e) => {
			$('body').addClass('body--loaded');

			setTimeout(() => {
				$('body').addClass('body--loaded-500ms');
			}, 500);
		});
	}
}

(function($) {
	function isOnFocus($el) {
		var wh = $(window).height();
		var wt = $(window).scrollTop();
		var wb = wt + wh;
		var et = $el.offset().top
		var eb = et + $el.height();

		if (et >= wt && et <= wb || eb >= wt && eb <= wb) {
			return true;
		} else {
			return false;
		}
	}

	function onViewFocus($el, callback) {
		$el.each(function() {
			var $this = $(this);
			var focused = false;

			if (isOnFocus($this)) {
				callback($this);
			} else {
				$(window).scroll(function() {
					if (isOnFocus($this)) {
						if (!focused) {
							callback($this);
						}

						focused = true;
					} else {
						focused = false;
					}
				});
			}
		});
	}

	function updateFloat() {
		var $body=$('body');

		var top = $(window).scrollTop();
		var wx = $(window).width();

		$('body').toggleClass('float', top > 0);
		$('body').toggleClass('float3', top > 150);
		$('body').toggleClass('nofloat', top == 0);

		$('body').toggleClass('body--mobile', wx <= 768);
	}

	(<any> $).fn.ajaxUpdate=function(url, data, options) {
		var $this=$(this);

		var options=$.extend({

		}, options);

		$.post(url, data, function(d) {
			$this.replaceWith(d);
			$this.trigger('onload');
		});
	};

	(<any> $).fn.ajaxLoader=function() {
		var $this=$(this);
		$('<div class="ajaxloader">').hide().fadeIn(100).appendTo($this);
	};

	(<any> $).fn.qSpinner=function(options) {
		var $this=$(this);

		var options=$.extend({
			min: 1,
			value: 1,

			onSpin: null,
			onLazySpin: null
		}, options);

		function spinUpdate(e?, ui?) {
			var val=ui!=null && ui.value!=null ? ui.value : $this.val();

			$this.trigger('spin', val);
		}

		var timer=null;

		(<any> $this).spinner({
			min: options.min,
			max: options.max,

			spin: function(e, ui) {
				spinUpdate(e, ui);

				if (options.onLazySpin!=null) {
					if (timer!=null)
						window.clearTimeout(timer);

					timer=window.setTimeout(function() {
						$this.trigger('lazyspin', ui.value);
					}, 500);
				}
			},

			change: spinUpdate
		});

		if (options.onSpin!=null)
			$this.on('spin', options.onSpin);

		if (options.onLazySpin!=null)
			$this.on('lazyspin', options.onLazySpin);

		$this.siblings('.ui-spinner-up').html('+');
		$this.siblings('.ui-spinner-down').html('-');

		(<any> $this).spinner('value', options.value);

		spinUpdate();

		return $this;
	};

	(<any> $).fn.switcher=function() {
		var $this=$(this);

		function switcher(name, $el, reverse?) {
			var $i=$('input[name="' + name + '"]', $this);

			function update(force?) {
				var val=$i.is(':checked');

				if (reverse) {
					val=!val;
				}

				if (val) {
					$el.slideDown(force ? 0 : null);
				} else {
					$el.slideUp(force ? 0 : null);
				}
			}

			$i.change(function () {
				update();
			});

			update(true);
		}

		$('[data-switcher]', $this).each(function () {
			var $this=$(this);
			switcher($this.data('switcher'), $this);
		});

		$('[data-revswitcher]', $this).each(function () {
			var $this=$(this);
			switcher($this.data('revswitcher'), $this, true);
		});

		return $this;
	};

	function detectFeatures() {
		function detectIE() {
			var ua = window.navigator.userAgent;

			var msie = ua.indexOf('MSIE ');
			if (msie > 0) {
				return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
			}

			var trident = ua.indexOf('Trident/');
			if (trident > 0) {
				var rv = ua.indexOf('rv:');
				return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
			}

			var edge = ua.indexOf('Edge/');
			if (edge > 0) {
				return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
			}

			return false;
		}


		var $html=$('html');

		var ie_ver=detectIE();

		if (ie_ver) {
			if (ie_ver>=12) {
				$html.addClass('df_edge');
			} else if (ie_ver==11) {
				$html.addClass('df_ie11 df_noflexcolumn');
			} else {
				$html.addClass('df_ie df_legacy df_noflex');
			}
		}
	}

	function windowOpen(url, name) {
		var width = 575;
		var height = 320;

		var left = ($(window).width()  - width)  / 2;
		var top = ($(window).height() - height) / 2;

		var opts = 'status=1,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left;

		return window.open(url, name, opts);
	}

	function scrollTo(top, force?) {
		if (force) {
			$('html,body').scrollTop(top);
		} else {
			$('html,body').animate({
				scrollTop: top
			}, 900);
		}
	}

	(<any> window).updateElements = function($parent) {
		$('.js-socials-share--facebook', $parent).click(function (e) {
			FB.ui({
				method: 'share',
				href: window.location.href
			});
		});

		$('.js-socials-share--googleplus', $parent).click(function (e) {
			windowOpen('https://plus.google.com/share?href=' + window.location.href, 'googleplus');
		});

		$('.js-socials-share--twitter', $parent).click(function (e) {
			windowOpen('https://twitter.com/share', 'twitter');
		});

		$('.counters__value', $parent).each(function () {
			var $this = $(this);
			var val = parseInt($this.text());

			if ($.isNumeric(val)) {
				$this.text('0');

				var cur = null;
				onViewFocus($this, function () {
					if (cur != null) {
						return;
					}

					cur = 0;

					var timer = window.setInterval(function () {
						if (cur > val) {
							window.clearTimeout(timer);
							timer = null;
							cur = val;
						}

						$this.text(Math.ceil(cur));

						cur += (val - cur) * 0.05;
					}, 30);
				});
			}
		});

		var anims = ['zoom'];

		$('.js-anim', $parent).each(function() {
			var $this = $(this);
			var $body = $('body');

			if (!$body.hasClass('body--loaded') && isOnFocus($this)) {
				return;
			}

			if ($body.hasClass('body--mobile') && $this.hasClass('js-anim--nomobile')) {
				return;
			}

			var i = Math.floor(anims.length * Math.random());
			var type = anims[i];

			var old_transform = $this.css('transform');
			var old_transition = $this.css('transition');
			var old_opacity = $this.css('opacity');

			$this.addClass('anim--initial anim--' + type);

			onViewFocus($this, function() {
				if (!$this.hasClass('anim--inited')) {
					$this.addClass('anim--inited');

					var rr = Math.random() * 400;

					setTimeout(function() {
						$this.css({
							'transform': old_transform,
							'opacity': old_opacity
						});
					}, 200 + rr);

					setTimeout(function() {
						$this.css({
							'transition': old_transition
						});
					}, 200 + 800 + rr);
				}
			});
		});

		$('.productbox', $parent).click(function (e) {
			var link = $(e.target).is('a') || $(e.target).parentsUntil($(this), 'a').length > 0;

			if (!link) {
				var $a = $('.productbox__title-inner', $(this));
				$a[0].click();
			}
		});

		Site.discover($parent);
	};

	$(document).ready(function() {
		detectFeatures();

		function initFilterBox() {
			var $styles = $('.filterbox__style-item');

			function setProductsStyle(style) {
				$styles.removeClass('filterbox__style-item--selected');
				$styles.filter('[data-class="' + style + '"]').addClass('filterbox__style-item--selected');

				$('.js-products-with-style')
					.removeClass('productslist--grid productslist--list')
					.addClass('productslist--' + style);

				$('.js-products-with-style .productbox')
					.removeClass('productbox--grid productbox--list')
					.addClass('productbox--' + style);
			}

			$styles.click(function () {
				var cls = $(this).data('class');

				setProductsStyle(cls);

				window.localStorage.setItem('products-style', cls);
			});

			var style = window.localStorage.getItem('products-style');

			if (style == null) {
				style = 'grid';
			}

			setProductsStyle(style);
		}

		function initCategories() {
			var $list = $('.categorieslist--i0');
			var $first = $('.categorieslist__item--tfirst', $list);

			$first = $first.not($first.first());

			$('<li class="categorieslist__item categorieslist__item--separator">').insertBefore($first);

			$('.categorieslist__item--selected').parentsUntil($list, '.categorieslist__item').addClass('categorieslist__item--focused')

			$list.addClass('categorieslist--inited');
		}

		function initCatMenu() {
			var $btn = $('.catbutton');
			var $list = $('.vshop__aside--list');


			$btn.click(function () {
				$list.toggleClass('vshop__aside--opened', !$list.hasClass('vshop__aside--opened'));
			});
		}

		initCategories();
		initCatMenu();
		initFilterBox();
	});
})(jQuery);

Site.init();
